import { memo } from 'react'
import type { RefCallback } from 'react'
import { SearchFilterBar } from '../../../shared/ui/SearchFilterBar'
import { PostsFeedView } from './PostsFeedView'
import { SentimentFilterChips } from './SentimentFilterChips'
import { ToimDigestPanel } from './ToimDigestPanel'
import { KeywordFilterDropdown } from './KeywordFilterDropdown'
import { FeedSortDropdown } from './FeedSortDropdown'
import { type PostsFeedViewModel } from '../state/usePostsFeed'

import type { FeedSort, SentimentFilter, SocialPlatform } from '../model/contracts'

type FeedContainerProps = {
  feed: PostsFeedViewModel
  onLoadMore: () => void
  onSearch?: (query: string) => void
  onPlatformChange?: (platform: SocialPlatform | 'all') => void
  onDateRangeChange?: (start?: string, end?: string) => void
  sentimentFilter: SentimentFilter[]
  onSentimentFilterChange: (next: SentimentFilter[]) => void
  keywordFilter: string[]
  onKeywordFilterChange: (next: string[]) => void
  topicKeywords: string[]
  feedSort: FeedSort
  onFeedSortChange: (next: FeedSort) => void
  sentinelRef: RefCallback<HTMLDivElement>
}

export const FeedContainer = memo(function FeedContainer({
  feed,
  onLoadMore,
  onSearch,
  onPlatformChange,
  onDateRangeChange,
  sentimentFilter,
  onSentimentFilterChange,
  keywordFilter,
  onKeywordFilterChange,
  topicKeywords,
  feedSort,
  onFeedSortChange,
  sentinelRef,
}: FeedContainerProps) {
  return (
    <div className="mx-auto flex w-full max-w-[680px] flex-col">
      <div className="sticky top-0 z-10">
        <SearchFilterBar
          onSearch={onSearch}
          onPlatformChange={onPlatformChange}
          onDateRangeChange={onDateRangeChange}
          isSticky={false}
        />
      </div>

      <div className="px-6 pt-4">
        <ToimDigestPanel posts={feed.posts} />
      </div>

      <div className="flex items-center gap-3 px-6 pt-3">
        <SentimentFilterChips
          value={sentimentFilter}
          onChange={onSentimentFilterChange}
        />
        <KeywordFilterDropdown
          keywords={topicKeywords}
          value={keywordFilter}
          onChange={onKeywordFilterChange}
        />
        <FeedSortDropdown value={feedSort} onChange={onFeedSortChange} />
      </div>

      <div className="feed-container flex min-h-0 flex-col gap-6 p-6 [contain:layout_style_paint]">
        <PostsFeedView
          posts={feed.posts}
          hasNextPage={feed.hasNextPage}
          isFetchingNextPage={feed.isFetchingNextPage}
          isLoading={feed.isLoading}
          onLoadMore={onLoadMore}
          sentinelRef={sentinelRef}
        />
      </div>
    </div>
  )
})
